import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { TiUser } from "react-icons/ti";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import { initFilterInput, renderColumns } from "../constants";
import Swal from "sweetalert2";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import CustomTable from "../../../components/common/Table/CustomTable";
import Title from "../../../components/common/Title/Title";
import { Link } from "react-router-dom";
import AppRoutePath from "../../../router/AppRoutePath";
import { convertAreaList } from "../helpers/convertAreaList";
import { AuthorizationList, CanAccess } from "../../../components/template/authorization/Authorization";

export default function AreaList() {
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [id, setId] = useState("");
  const [areaName, setAreaName] = useState();
  const [cityName, setCityName] = useState();
  const [subDistric, setSubdisctric] = useState();
  const [modalAdd, setMoadalAdd] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [tablePagination, setTablePagination] = useState({});

  useEffect(() => {
    getData();
  }, [filterInput]);

  const getData = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}area`;
    let params = {
      province: filterInput.searchName,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
    };
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        let data = response.data.data;
        setRecords(convertAreaList(data.items));

        setTotalRecords(data.total_item);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleSubmit = () => {
    setSubmitting(true);

    let data = {
      name: areaName,
      city: cityName,
      subDistric: subDistric,
    };

    if (id === "") {
      let url = `${process.env.REACT_APP_BASE_API_URL}area`;
      httpclient
        .POST(url, data)
        .then((response) => {
          console.log(response);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
          setMoadalAdd(false);
          handleCloseModal();
        })
        .catch((error) => {
          if (error.response) {
            setSubmitting(false);
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
            setSubmitting(false);
          }
        });
    } else {
      let url = `${process.env.REACT_APP_BASE_API_URL}area/${id}`;
      httpclient
        .PUT(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
          setMoadalAdd(false);
          setSubmitting(false);
          handleCloseModal();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
            setSubmitting(false);
          }
        });
    }
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}area/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus area " + record.area,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  const handleEdit = (record) => {
    setMoadalAdd(true);
    setAreaName(record.name);
    setCityName(record.cityName);
    setSubdisctric(record.subDistric);
    setId(record.id);
  };

  const handleCloseModal = () => {
    setSubmitting(false);
    setMoadalAdd(false);
    setAreaName("");
    setCityName("");
    setSubdisctric("");
    setId("");
  };

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (name == "search") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
    if (name == "pageSize") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          pageSize: value,
        }));
      }
    }
  };

  return (
    <>
      <div>
        <div className="p-3">
          <div className="row">
            <div className="col-10">
              <Title text="Area Jemput Gadai" />
              <Breadcrumb current="Area Jemput Gadai" />
            </div>
            <div className="col-2">
              <div
                style={{
                  padding: 13,
                  border: "1px solid #DCDCDC",
                  borderRadius: 5,
                  height: 50,
                  width: 200,
                }}
              >
                <div
                  style={{
                    fontSize: 18,
                    color: "#303030",
                  }}
                >
                  <TiUser
                    style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                  />
                  <span style={{ fontWeight: 700 }}>{totalRecords}</span> Total
                  Area
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 mt-2">
            <div className="col-1 pl-0">
              <div style={{ color: "#A6A6A6" }}>Tampilkan</div>
              <input
                type="number"
                name="pageSize"
                className="form-control border-97A0AE mt-1"
                placeholder="10"
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div className="">
              <div style={{ color: "#A6A6A6" }}>Provinsi</div>
              <input
                type="text"
                name="search"
                className="form-control border-97A0AE mt-1"
                placeholder="Cari"
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div className="ml-auto">
              <CanAccess
                role={AuthorizationList.create_area}
                yes={
                  <Link to={AppRoutePath.ADD_AREA_LIST}>
                    <button className=" mt-5 ml-3 btn border-438EBC bgc-2C465C text-white">
                      + Tambah Area
                    </button>
                  </Link>
                }
              />
            </div>
          </div>
          <div className="mt-3">
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>
    </>
  );
}
